module.exports = __webpack_public_path__ + "assets/media/envelope.0085021b.svg";